import { RichTextStyle } from '../RichText';
import { Nav, NavContainer } from './TabNavigation.styles';

type Props = React.PropsWithChildren<{
  textStyle?: RichTextStyle;
  hasBadge?: boolean;
}>;

const TabNavigation = ({
  children,
  hasBadge = false,
  textStyle = RichTextStyle.Primary,
}: Props) => (
  <NavContainer hasBadge={hasBadge}>
    <Nav aria-label="Tabs" role="tablist" textStyle={textStyle}>
      {children}
    </Nav>
  </NavContainer>
);
export { TabNavigation };
